import { Action, createReducer, on } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { terminalActions } from './terminal.action';
import { CliCommandResponseDto } from '../../../api/models';

export interface TerminalState {
  result: {
    state: ILoaderActionPayload;
    data?: CliCommandResponseDto;
  };
}

const initialState: TerminalState = {
  result: {
    state: {
      value: LoadingState.NONE,
    },
  },
};

const reducer = createReducer(
  initialState,
  on(terminalActions.load, (state) => ({
    ...state,
    result: { state: { value: LoadingState.LOADING } },
  })),
  on(terminalActions.done, (state, props) => ({
    ...state,
    result: { state: props.state, data: props.data },
  })),
  on(terminalActions.setState, (state, props) => ({
    ...state,
    result: { state: props.state },
  })),
);

export function terminalReducer(state: TerminalState | undefined, action: Action) {
  return reducer(state, action);
}
